import { GetListDefaultContentPackagesMeta, GetListDefaultContentPackagesPayload } from 'types/store/GetListDefaultContentPackages';
import { createAsyncReducer } from 'utils/Redux';

import { getListDefaultContentPackagesActions } from '../actions';

export default createAsyncReducer<GetListDefaultContentPackagesMeta, GetListDefaultContentPackagesPayload>(getListDefaultContentPackagesActions);
